import { cn } from "@/utils/cn";
import { useNavigate } from "react-router-dom";

export const PencomBackButton = ({ title, className }: { title?: string, className?: string }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div
      className={cn("flex cursor-pointer hover:opacity-80 transition-opacity duration-300 flex-row gap-x-2 items-center", className)}
      onClick={handleBack}
    >
      <img src="/assets/icons/long-arrow.svg" alt="back" className="w-6 h-6" loading="lazy" />
      <p className="font-clash-display text-medium-dark-grey text-xs font-semibold tracking-[-0.06px]">
        {title || "Back to dashboard"}
      </p>
    </div>
  );
};